import { Pagination } from '@material-ui/lab'

import { PaymentTermListProps } from './PaymentTermListDesktop'
import TenantTable from './PaymentTermTable'
import useStyles from './styles/PaymentTermListDesktop.styles'

const TenantListMobile: React.FC<PaymentTermListProps> = ({
  refetch,
  filteredPaymentTerms,
  page,
  perPage,
  loading,
  numberOfPages,
  setPage
}) => {
  const classes = useStyles()
  return (
    <div>
      <TenantTable
        refetch={refetch}
        paymentTerms={filteredPaymentTerms.slice(
          (page - 1) * perPage,
          page * perPage
        )}
        loading={loading}
      />
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size="small"
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
export default TenantListMobile
